<div fxLayout="row" fxFlex="100%" fxLayoutAlign="space-between center">
    <mat-icon fxFlex="40">done</mat-icon>
    <strong fxFlex="60" >
         <b>{{Message}}</b>
    </strong>
    <mat-icon fxFlex (click)="closeToastNotification()" >close</mat-icon>
</div>


